/**
 * Добавляет параметр к URL
 * @param url - исходный URL
 * @param paramName - имя параметра
 * @param paramValue - значение параметра
 * @returns URL с добавленным параметром
 */
export const addUrlParam = (url: string, paramName: string, paramValue: string): string => {
    let urlObj;
    try {
        urlObj = new URL(url, window.location.origin);
        urlObj.searchParams.set(paramName, paramValue);
    } catch (e) {
        return url;
    }

    return urlObj.pathname + urlObj.search;
};
